import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../const';
import utils from '../utils';
import classnames from 'classnames';
import theme from './theme';

class ColorSelector extends React.Component {
    onClick = (color, event) => {
        event.preventDefault();
        this.props.onChange(color);
    };

    renderColor = color => {
        const is_active = this.props.color === color;
        const dotClasses = classnames(color, {
            active: is_active,
        });
        const colorOptionClasses = classnames('color-option', color, {
            active: is_active,
        });

        const checkmark = () => {
            if (is_active) {
                return <i className="cl-icon cl-icon-check" />;
            }
        };

        const changeColor = this.onClick.bind(this, color);
        return (
            <ColorOption
                key={color}
                onClick={changeColor}
                onKeyDown={utils.ifSpace(changeColor)}
                className={colorOptionClasses}
            >
                <Dot className={dotClasses}>{checkmark()}</Dot>

                <ColorLabel>{color}</ColorLabel>
                {is_active ? <span className="aural">selected</span> : null}
            </ColorOption>
        );
    };

    render() {
        return (
            <ColorOptions>
                {COLORS.map(color => this.renderColor(color))}
            </ColorOptions>
        );
    }
}

const ColorOptions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const ColorOption = styled.button`
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    padding: 0.25rem;
    margin-right: 0.25rem;
    border-radius: 3px;
    border: 1px solid white;

    &:hover,
    &:focus {
        text-decoration: none;
    }

    &:hover:not(.active) {
        background: #f5f5f5;
        border: 1px solid #e9e9e9;
    }

    // active state colors
    ${Object.keys(theme.colors.highlights).map(color => {
        return `&.active.${color} {
                border: 1px solid ${theme.colors.highlights[color].default};
                background: ${theme.colors.highlights[color].light};
            }`;
    })};
`;

const dot_size = 16;
const Dot = styled.span`
    display: inline-block;
    width: ${dot_size}px;
    height: ${dot_size}px;
    border-radius: 50%;
    margin-right: 0.25rem;
    text-align: center;
    line-height: ${dot_size}px;

    &:hover {
        cursor: pointer;
    }

    // color specifics
    ${Object.keys(theme.colors.highlights).map(color => {
        return `
            // background and hover colors
            &.${color} {
                background-color: ${theme.colors.highlights[color].default};

                &:hover {
                    background-color: ${theme.colors.highlights[color].hover};
                }

                // font colors
                &.active {
                    color: ${theme.colors.highlights[color].fontColor};
                }
            }
        `;
    })} .cl-icon:before {
        font-size: 0.7rem;
    }
`;

const ColorLabel = styled.span`
    text-transform: capitalize;
    color: #444;
    font-weight: 400;
    font-size: 0.7rem;
`;

ColorSelector.propTypes = {
    color: PropTypes.oneOf(['', ...COLORS]).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ColorSelector;



// WEBPACK FOOTER //
// ./src/components/color_selector.jsx